import {Component, ContentChild, forwardRef, Input, OnInit, TemplateRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NGXLogger} from 'ngx-logger';

@Component({
    selector: 'toggles',
    template: `
        <ion-item *ngFor="let item of items" (click)="toggle(id ? item[id]: item)" color="light">
            <ion-icon [name]="isSelected(id ? item[id]: item) ? 'radio-button-on-sharp': 'radio-button-off-sharp'" slot="end"></ion-icon>
            <ng-template [ngTemplateOutlet]="templ" [ngTemplateOutletContext]="{item: item}"></ng-template>
        </ion-item>
    `,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => TogglesComponent),
        multi: true
    }],
    standalone: false
})
export class TogglesComponent implements ControlValueAccessor, OnInit {
    @ContentChild(TemplateRef, {static: true}) templ;

    public values: string[];

    @Input()
    public items: any[];

    @Input()
    public label: string;

    @Input()
    public id: string;

    constructor(private logger: NGXLogger) {
    }

    ngOnInit(): void {
    }

    writeValue(values: string[]) {
        this.values = values ? [...values] : [];
    }

    propagateChange = (_: any) => {
    };
    propagateTouch = () => {
    };

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched(fn) {
        this.propagateTouch = fn;
    }

    isSelected(value: string): boolean {
        return this.values && this.values.some(val => val === value);
    }

    toggle(value: string) {
        if (!this.values) {
            this.values = [];
        }
        const index = this.values.findIndex(val => val === value);
        if (index > -1) {
            this.values.splice(index, 1);
        } else {
            this.values.push(value);
        }
        this.logger.debug(`propagating changes ${this.values}`);

        // remove values not present in item list
        this.values = this.values.filter(val => {
            return this.items.some(item => {
                if (this.id) {
                    return item[this.id] === val;
                } else {
                    return item === val;
                }
            });
        });

        if (this.values.length === 0) {
            this.values = null;
        }

        this.propagateChange(this.values);
        this.propagateTouch();
    }
}
